import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppStore } from '../../store/useAppStore'
import { usePlatform } from '@shared/platform'
import { ENV } from '@shared/config/env'
import { ROUTES } from '@shared/config/routes'
import { logout } from '@features/web-auth'
import { Button } from '@shared/ui/Button'
import { ProfileLoginMethods } from '@widgets/profile-login-methods'
import {
  ProfileHeader,
  SubscriptionSection,
} from './components'
import './ProfilePage.css'

const ProfilePage = () => {
  const { user, profile, subscription, hasActiveSubscription, clearAuth, setSubscription } = useAppStore()
  const navigate = useNavigate()
  const platform = usePlatform()
  const hapticFeedback = (type: Parameters<typeof platform.haptic>[0]) => platform.haptic(type)

  // В web-сборке единственный источник правды о подписке — profile.subscription.
  // Синхронизируем legacy-стор subscription, чтобы SubscriptionSection/hasActiveSubscription
  // не отдавали залипшие данные из localStorage (например, от прошлых TG-заходов).
  useEffect(() => {
    if (!ENV.IS_WEB) return
    const s = profile?.subscription ?? null
    if (s && s.is_active) {
      setSubscription({
        isActive: true,
        expiresAt: s.subscription_end_timestamp,
        type: s.subscription_type as 'monthly' | 'yearly'
      })
    } else {
      setSubscription({ isActive: false })
    }
  }, [profile, setSubscription])

  // Источник данных юзера для ProfileHeader:
  //   - в web-сборке: имя из profile.name (или TG-контакта, если уже привязан)
  //   - в tg-сборке: из user (TMA initDataUnsafe)
  const headerUser = ENV.IS_WEB && profile
    ? {
        id: profile.user_id,
        first_name: profile.telegram?.first_name?.trim() || profile.name || '',
        last_name: profile.telegram?.last_name ?? '',
        username: profile.telegram?.username ?? '',
        language_code: 'ru',
        photo_url: ''
      }
    : user

  const handleSubscribeClick = () => {
    hapticFeedback('light')
  }

  const handleSettingsClick = () => {
    hapticFeedback('light')
    window.open('https://t.me/secretchathelp', '_self')
  }

  const handleLogout = async () => {
    try { await logout() } catch { /* ignore */ }
    clearAuth()
    navigate(ROUTES.AUTH, { replace: true })
  }

  return (
    <div className="profile-page">
      <ProfileHeader user={headerUser} />

      <ProfileLoginMethods />

      <SubscriptionSection
        hasActiveSubscription={hasActiveSubscription}
        subscription={subscription}
        onSubscribeClick={handleSubscribeClick}
        onSettingsClick={handleSettingsClick}
      />

      {ENV.IS_WEB && (
        <div className="profile-page__logout">
          <Button variant="secondary" onClick={handleLogout} block>Выйти</Button>
        </div>
      )}
    </div>
  )
}

export default ProfilePage
